import axios from "../api"
import { getToken } from "../util/util"

axios.defaults.timeout = 1000000

export const getLabels = () =>
  axios.get(`/labels/all`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    }
  }).then((res) => res.data)

export const createLabel = (name, color) =>
  axios.post('/labels/', { name, color }, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    }
  }).then((res) => res.data)

export const updateCVLabels = (cvId, labelIds) =>
  axios.put('/labels/assign', { taskIds: [cvId], labelIds }, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    }
  }).then((res) => res.data)